import { MutationTree } from 'vuex'
import { ITalkerState, state as init } from '@/store/talker'
import { Types, Store, Fetched, Update, Query, Loading, Current, Reset } from '@/store/talker/types'

const mutations: MutationTree<ITalkerState> = {
  [Types.store]: (state, action: Store) => {
    for (const prop of action.payload) {
      state.byIds = {
        ...state.byIds,
        [prop.id!]: prop
      }
    }
  },
  [Types.fetched]: (state, action: Fetched) => {
    state.fetched = action.payload
  },
  [Types.udpate]: (state, action: Update) => {
    const index = state.fetched.findIndex((prop) => prop.id === action.payload.id)
    if (index >= 0) {
      state.fetched.splice(index, 1, action.payload)
    }
    state.byIds[action.payload.id!] = action.payload
  },
  [Types.query]: (state, action: Query) => {
    state.query = action.payload
  },
  [Types.loading]: (state, action: Loading) => {
    state.loading = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.reset]: (state, action: Reset) => {
    state.reset = action.payload
  },
  [Types.clear]: (state) => {
    Object.assign(state, init())
  }
}

export default mutations
